export default __webpack_public_path__ + "static/media/closet5-before2-1920w.22aca7f5.png";